import { CircularProgress, Typography } from "@material-ui/core";
import React from "react";
import "./style.css";

export const Widget = ({ name, value, top, loading, maxWidth }) => {
  return (
    <div className="widget-container">
      <div className="widget-inner-container">

        <Typography style={{ color: "#006B7A", fontWeight: 600, marginBottom:30, maxWidth:maxWidth }} variant="h5">{name}</Typography>

        <div className="widget-value-container" style={{width: 'inherit'}}>
          {loading
            ? <CircularProgress
              color="inherit"
              size={20}
              style={{display: 'flex', alignItems: 'center', flexDirection:'column', margin:'auto'}}
            />
            :
            <Typography className="widget-effect" variant="h2" style={{
              color: "black", width: 'inherit', whiteSpace: 'nowrap', overflow: 'hidden'
            }}
            >
              {top && <span>{top}</span>}&nbsp; {value}
            </Typography>

          }
        </div>
      </div>
    </div>
  );
};
